import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, FileText } from 'lucide-react';
import { StatutoryFilings } from '@/components/compliance/StatutoryFilings';
import { CIPCFilingJobs } from '@/components/compliance/CIPCFilingJobs';
import EllaComplianceDashboard from '@/components/compliance/EllaComplianceDashboard';
import GovernanceDeadlines from '@/components/compliance/GovernanceDeadlines';
import CompanyRunwaySensitivityCard from '@/components/compliance/CompanyRunwaySensitivityCard';
import { useTenantStore } from '@/hooks/useTenantStore';
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

const Compliance = () => {
  const { tenantId } = useTenantStore();
  const [companyName, setCompanyName] = useState<string>('Company');

  useEffect(() => {
    async function loadCompany() {
      if (!tenantId) return;

      const { data, error } = await supabase
        .from('companies')
        .select('name')
        .eq('id', tenantId)
        .single();

      if (data && !error) {
        setCompanyName(data.name);
      }
    }

    loadCompany();
  }, [tenantId]);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Compliance</h1>
          <p className="text-muted-foreground">
            Statutory filings and regulatory compliance tracking
          </p>
        </div>

        {tenantId ? (
          <>
            <div data-tour="upcoming-deadlines">
              <GovernanceDeadlines companyId={tenantId} />
            </div>

            <div data-tour="risk-score">
              <EllaComplianceDashboard companyId={tenantId} />
            </div>

            <CompanyRunwaySensitivityCard companyId={tenantId} />

            <StatutoryFilings companyId={tenantId} companyName={companyName} />

            <CIPCFilingJobs companyId={tenantId} />

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Shield className="h-5 w-5" />
                  Audit Log
                </CardTitle>
                <CardDescription>Append-only audit trail for regulatory compliance</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="text-sm text-muted-foreground">Audit log viewer coming soon</div>
              </CardContent>
            </Card>
          </>
        ) : (
          <Card>
            <CardContent className="p-8 text-center">
              <FileText className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">
                Please select a company to view compliance data
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Compliance;
